<!-- Breadcrumb Navigation -->
<nav aria-label="breadcrumb">
    <ol class="breadcrumb">
        <li class="breadcrumb-item">
            <a routerLink="/dashboard" style="color: #003E53;">Dashboard</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">Lab Test</li>
    </ol>
</nav>

<div class="row">
    <div class="col-xl-12">

        <!-- Card Wrapper -->
        <app-card cardTitle="Basic Table" [options]="false" blockClass="table-border-style">

            <!-- Header Section -->
            <div class="row align-items-center mb-3 gx-2">
                <div class="col-9 col-md-6">
                    <h5 class="mb-0 text-dark fw-bold">Lab Test</h5>
                </div>
                <div class="col-3 col-md-6 d-flex justify-content-end" *appHasRole="['TEST-ADD']">
                    <!-- Add Wards Button -->
                    <button type="button"
                        class="btn btn-sm btn-primary rounded-2 d-flex align-items-center justify-content-center p-0"
                        *appHasRole="['TEST-ADD']" (click)="openModel('Add', null)" style="width: 25px; height: 25px;"
                        title="Add New Wards">
                        <mat-icon fontIcon="add"></mat-icon>
                    </button>
                </div>
            </div>

            <hr class="m-0 p-0" />

            <!-- Search Box -->
            <div class="row">
                <div class="col-12">
                    <mat-form-field class="dense w-100">
                        <mat-label>Search By Name</mat-label>
                        <input matInput name="name" (keyup)="onSearchChange($event)" class="w-100" />
                    </mat-form-field>
                </div>
            </div>

            <!-- Table Section -->
            <div class="table-responsive">
                <div class="mat-elevation-z8">
                    <table mat-table [dataSource]="dataSource" class="table-bordered table-hover compact-table">

                        <!-- Sr No -->
                        <ng-container matColumnDef="position">
                            <th mat-header-cell *matHeaderCellDef>Sr. No</th>
                            <td mat-cell *matCellDef="let row; let i = index">
                                {{ i + 1 }}
                            </td>
                        </ng-container>

                        <!-- Name -->
                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>Name</th>
                            <td mat-cell *matCellDef="let element">
                                {{ element.name }}
                            </td>
                        </ng-container>

                        <!-- Price -->
                        <ng-container matColumnDef="price">
                            <th mat-header-cell *matHeaderCellDef>Price</th>
                            <td mat-cell *matCellDef="let element">
                                ₹ {{ element.price || 0 }}
                            </td>
                        </ng-container>


                        <!-- Action-->
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef >Action</th>

                            <td mat-cell *matCellDef="let element" >

                                <!-- Edit Button -->
                                <button mat-icon-button class="btn btn-sm" *appHasRole="['TEST-CHANGE']"
                                    (click)="openModel('Edit', element._id)">

                                    <mat-icon fontIcon="edit" class="c_btn"></mat-icon>
                                </button>

                                <!-- Delete Button -->
                                <button mat-icon-button class="btn btn-sm text-danger" *appHasRole="['TEST-DELETE']"
                                    (click)="deleteItem(element._id)">

                                    <mat-icon fontIcon="delete" class="c_btn"></mat-icon>
                                </button>

                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="t_head"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                    </table>
                </div>
            </div>

            <!-- Pagination -->
            <mat-paginator #paginator [length]="total" [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50, 100]"
                (page)="getAllCategories($event)"></mat-paginator>

        </app-card>
    </div>
</div>



<!-- Wards Modal -->
<div class="modal fade" id="wardModal" tabindex="-1" aria-labelledby="wardModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header border-0 pb-0">
                <h5 class="modal-title fs-5 fw-semibold" id="wardModalLabel">
                    {{ formType }} Test
                </h5>
                <button type="button" class="btn-close" (click)="hideModel()"></button>
            </div>

            <!-- Modal Body -->
            <div class="modal-body pt-1">
                <form [formGroup]="categoryForm" (ngSubmit)="submit()">

                    <!-- Name -->
                    <div class="mb-3">
                        <label class="form-label small text-muted mb-1">Test Name</label>
                        <input type="text" formControlName="name" class="form-control form-control-sm"
                            placeholder="Enter Test Name" />
                    </div>

                    <!-- Price -->
                    <div class="mb-3">
                        <label class="form-label small text-muted mb-1">Price</label>
                        <input type="number" formControlName="price" class="form-control form-control-sm"
                            placeholder="Enter Price" />
                    </div>
                    <!-- Modal Actions -->
                    <div class="modal-footer border-0 pt-0">
                        <button type="button" class="btn btn-sm btn-light" (click)="hideModel()">Cancel</button>
                        <button type="submit" class="btn btn-sm btn-primary px-3" [disabled]="categoryForm.invalid">
                            Save
                        </button>
                    </div>

                </form>
            </div>

        </div>
    </div>
</div>